export default "__VITE_ASSET__Dvy6zQb7__"